export var NOOP = function () { };
export function newArray(length) {
    return Array.apply(null, Array(length));
}
